import React, { FunctionComponent, Suspense } from "react";
import PreviewAndVisualizationModalContainer from "../../containers/PreviewAndVisualizationModalContainer";
import useModal from "../../../../hooks/useModal";
import { RenderWhen } from "../../../../components";

interface IYaraStringMatchLinkProps {
  sha1: string;
  sourceId: number;
  relationshipId: number;
  stringMatchCount: number;
  initialRulesetName?: string;
  initialRuleName?: string;
}

const YaraStringMatchLink: FunctionComponent<IYaraStringMatchLinkProps> = ({
  relationshipId,
  stringMatchCount,
  sha1,
  sourceId,
  initialRulesetName,
  initialRuleName
}) => {
  const [previewModalShow, , togglePreviewModal] = useModal();

  return (
    <Suspense fallback={"Loading..."}>
      <span onClick={togglePreviewModal} className={"basic-link-element"}>
        {stringMatchCount ?? 0}&nbsp;Strings
      </span>

      <RenderWhen condition={previewModalShow}>
        <PreviewAndVisualizationModalContainer
          sha1={sha1}
          sourceId={sourceId}
          relationshipId={relationshipId}
          initialRulesetName={initialRulesetName}
          initialRuleName={initialRuleName}
          onHide={togglePreviewModal}
        />
      </RenderWhen>
    </Suspense>
  );
};

export default YaraStringMatchLink;
